module.exports = __webpack_public_path__ + "static/media/historic_call_marker_hover.325b1663.svg";